import { gql } from "@apollo/client";
import React, { FC, useMemo } from "react";
import { useFeatureFlagsQuery } from "./FeatureFlagContext.generated";

export type FlagDict = { [key: string]: boolean };

export const FeatureFlagContext = React.createContext<FlagDict>({});
// False until the FeatureFlags query has resolved once; lets pages avoid
// rendering the flag-off branch during the initial load.
export const FeatureFlagsLoadedContext = React.createContext<boolean>(false);

type Props = {
  children: React.ReactNode;
};

const FeatureFlagContextProvider: FC<Props> = ({ children }) => {
  const { data } = useFeatureFlagsQuery();
  const flagDict = useMemo(() => {
    if (!data) {
      return {};
    }
    return data.FeatureFlags.reduce((accum: FlagDict, curr) => {
      accum[curr.name as string] = curr.enabled;
      return accum;
    }, {});
  }, [data]);
  return (
    <FeatureFlagContext.Provider value={flagDict}>
      <FeatureFlagsLoadedContext.Provider value={data !== undefined}>
        {children}
      </FeatureFlagsLoadedContext.Provider>
    </FeatureFlagContext.Provider>
  );
};

gql`
  query FeatureFlags {
    FeatureFlags {
      name
      enabled
      userFacingName
    }
  }
`;
export default FeatureFlagContextProvider;
